// extracted by mini-css-extract-plugin
export default {"heroDiv":"hero_heroDiv__8nQP4","descriptionDiv":"hero_descriptionDiv__i6HTy","heroNavDiv":"hero_heroNavDiv__4FJol","imageNavIcon":"hero_imageNavIcon__3rh8l"};